import { render, staticRenderFns } from "./customTab.vue?vue&type=template&id=d3e1cdfa&scoped=true&"
import script from "./customTab.vue?vue&type=script&lang=js&"
export * from "./customTab.vue?vue&type=script&lang=js&"
import style0 from "./customTab.vue?vue&type=style&index=0&id=d3e1cdfa&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d3e1cdfa",
  null
  
)

export default component.exports